"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const formik_1 = require("formik");
const react_1 = tslib_1.__importStar(require("react"));
const react_if_1 = require("react-if");
const react_use_1 = require("react-use");
const reactstrap_1 = require("reactstrap");
const reusables_1 = require("../../../comps/reusables");
const CenteredRow_1 = require("../../../comps/reusables/CenteredRow");
const react_2 = require("@osmosys/react");
const utils_1 = require("../../../utils");
const Yup = tslib_1.__importStar(require("yup"));
const react_hanger_1 = require("react-hanger");
const hooks_1 = require("../../../hooks");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
const PasswordInput_1 = require("../../../comps/reusables/PasswordInput");
const OsmosysAppVersionText_1 = require("../../../comps/navs/AppNav/OsmosysAppVersionText");
const MagicLinkButton = ({ email }) => {
    email = (email || '').trim();
    const [emailIsValid, toggleEmailIsValid] = react_use_1.useToggle(false);
    react_use_1.useDebounce(() => {
        const isValid = email.trim().match(
        // eslint-disable-next-line no-useless-escape
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        if (!!isValid !== emailIsValid) {
            toggleEmailIsValid(true);
        }
    }, 500, [email]);
    const { send, result } = hooks_1.useSendMagicLink(email);
    return (react_1.default.createElement(reactstrap_1.Fade, { tag: react_2.OsmosysDiv, osysName: "MagicLinkButton.outer", in: !!emailIsValid, "data-transactional-email-id": result.data && result.data.sendMagicLink && result.data.sendMagicLink.id },
        react_1.default.createElement(react_if_1.When, { condition: !!emailIsValid },
            react_1.default.createElement(react_2.OsmosysErrorAlert, { resource: "TransactionalEmail", action: "create", apolloError: result.error }),
            react_1.default.createElement(react_2.OsmosysTooltip, { label: result.error
                    ? 'Failed to send magic link. Click to retry'
                    : result.loading
                        ? `Sending magic link to ${email}...`
                        : result.data
                            ? `Magic link sent to ${email}`
                            : `Send a magic login link to ${email} for one-time access to Osmosys.` },
                react_1.default.createElement(reactstrap_1.Button, { href: "#", color: "light", disabled: !!result.data || result.loading, onClick: e => {
                        e.preventDefault();
                        send();
                    }, className: utils_1.classnames({
                        'text-danger': result.error,
                        'text-primary': result.loading,
                        'text-reset': !result.loading && !result.data && !result.error,
                        'text-success': !!result.data,
                    }) },
                    react_1.default.createElement(CenteredRow_1.CenteredRow, null,
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: result.loading
                                ? pro_solid_svg_icons_1.faSpinnerThird
                                : result.data
                                    ? pro_solid_svg_icons_1.faCheck
                                    : pro_solid_svg_icons_1.faMagic, spin: result.loading }),
                        react_1.default.createElement(react_if_1.When, { condition: !!result.data },
                            react_1.default.createElement("div", { className: "ml-2" }, "Magic link sent"))))))));
};
function BaseAuthModal({ title, fields, isOpen, mutation, linkComp, formProps, buttonText, showButton, extraButton, showMagicLink, emailIsDisabled, getVars, variables, successText, osysSubType, }) {
    var _a, _b;
    const { match } = use_react_router_1.default();
    const { state, setState } = react_hanger_1.useSetState({
        completed: false,
        emailFocused: false,
        fullNameFocused: false,
        parsedError: false,
        passwordFocused: false,
        showCapsLockWarning: false,
        showLabels: false,
        showWarningMessage: false,
    });
    react_1.useEffect(() => {
        const t = setTimeout(() => {
            setState({
                showLabels: true,
            });
        }, 400);
        return () => {
            clearTimeout(t);
        };
    }, [setState]);
    const validationSchema = react_1.useMemo(() => {
        const schema = {
            email: Yup.string()
                .email('Email address is invalid')
                .lowercase('Must be lowercase')
                .required('Required'),
            fullName: Yup.string()
                .min(2, 'Too short')
                .max(40, 'Too long')
                .required('Required'),
            password: Yup.string()
                .min(2, 'Too short')
                .required('Required'),
        };
        // Filter the schema down to just what fields are being rendered
        const limitedSchema = Object.keys(schema)
            .filter(k => fields.includes(k))
            .reduce((obj, key) => {
            obj[key] = schema[key];
            return obj;
        }, {});
        return Yup.object().shape(limitedSchema);
    }, [fields]);
    react_1.useEffect(() => {
        if (state.completed) {
            const t = setTimeout(() => {
                setState({
                    showWarningMessage: true,
                });
            }, 2500);
            return () => {
                clearTimeout(t);
            };
        }
        return () => { };
    }, [setState, state.completed]);
    const { showLabels } = state;
    const { loadApp, appSettings } = hooks_1.useOsmosysContext();
    return (react_1.default.createElement(react_2.OsmosysModal, { isOpen: isOpen !== false, centered: true, backdropClassName: "bg-dark", osysName: "BaseAuthModal", osysSubType: osysSubType },
        react_1.default.createElement(reactstrap_1.ModalBody, null,
            react_1.default.createElement(reactstrap_1.Container, null,
                react_1.default.createElement(reactstrap_1.Row, { className: "justify-content-md-center py-2" },
                    react_1.default.createElement(reactstrap_1.Col, null,
                        react_1.default.createElement("div", { className: "mb-2" },
                            react_1.default.createElement(react_2.OsmosysLogo, { defaultTooltip: react_1.default.createElement(OsmosysAppVersionText_1.OsmosysAppVersionText, { version: process.env.GIT_SHA ||
                                        (appSettings && appSettings.version) ||
                                        '' }), height: "64px", width: "64px" })),
                        react_1.default.createElement("h3", { "data-name": "auth-modal-title" }, title),
                        react_1.default.createElement(reusables_1.Form, Object.assign({ mutationProps: {
                                mutation,
                                onCompleted: () => {
                                    setState({
                                        completed: true,
                                    });
                                    if (loadApp) {
                                        loadApp.refetch();
                                    }
                                },
                            }, valuesToVariables: values => {
                                const token = match.params.token;
                                return (getVars &&
                                    getVars(Object.assign({ token }, values)));
                            }, blurOnSubmit: true, formikProps: {
                                initialValues: {
                                    email: ((_a = variables) === null || _a === void 0 ? void 0 : _a.email) ? variables.email : '',
                                    fullName: ((_b = variables) === null || _b === void 0 ? void 0 : _b.fullName) ? variables.fullName : '',
                                    password: '',
                                },
                                validationSchema,
                            } }, formProps), ({ errors, touched, isSubmitting, setFieldValue, values }, mutationResult) => {
                            return (react_1.default.createElement(react_1.default.Fragment, null,
                                !!linkComp && linkComp,
                                react_1.default.createElement(react_if_1.When, { condition: !!(fields.length > 0) },
                                    react_1.default.createElement("div", { className: "py-2" },
                                        fields.includes('fullName') && (react_1.default.createElement(reactstrap_1.Collapse, { isOpen: fields.includes('fullName') },
                                            react_1.default.createElement(reactstrap_1.FormGroup, { id: "fullName-form-group" },
                                                react_1.default.createElement(reactstrap_1.Collapse, { isOpen: showLabels },
                                                    react_1.default.createElement(reactstrap_1.Label, null, "Full name")),
                                                react_1.default.createElement(reactstrap_1.Input, { placeholder: "full name", tag: formik_1.Field, type: "text", name: "fullName", onFocus: () => setState({
                                                        fullNameFocused: true,
                                                    }) }),
                                                react_1.default.createElement(reactstrap_1.Collapse, { className: "form-error", tag: reactstrap_1.FormText, color: "danger", isOpen: errors.fullName && !!touched.fullName }, errors.fullName)))),
                                        fields.includes('email') && (react_1.default.createElement(reactstrap_1.Collapse, { isOpen: fields.includes('email') },
                                            react_1.default.createElement(reactstrap_1.FormGroup, { id: "email-form-group" },
                                                react_1.default.createElement(reactstrap_1.Collapse, { isOpen: showLabels },
                                                    react_1.default.createElement(reactstrap_1.Label, null, "Email")),
                                                react_1.default.createElement(reactstrap_1.Input, { placeholder: "Email", tag: formik_1.Field, type: "email", name: "email", autoComplete: "username", disabled: !!emailIsDisabled, onFocus: () => setState({ emailFocused: true }) }),
                                                react_1.default.createElement(reactstrap_1.Collapse, { className: "form-error", tag: reactstrap_1.FormText, color: "danger", isOpen: errors.email && !!touched.email }, errors.email)))),
                                        fields.includes('password') && (react_1.default.createElement(reactstrap_1.Collapse, { isOpen: fields.includes('password') },
                                            react_1.default.createElement(reactstrap_1.FormGroup, { id: "password-form-group" },
                                                react_1.default.createElement(reactstrap_1.Collapse, { isOpen: showLabels },
                                                    react_1.default.createElement(reactstrap_1.Label, null, "Password")),
                                                react_1.default.createElement(PasswordInput_1.PasswordInput, { value: values.password, onChange: pass => {
                                                        setFieldValue('password', pass);
                                                    }, onFocusChange: passwordFocused => {
                                                        setTimeout(() => {
                                                            setState({
                                                                passwordFocused,
                                                            });
                                                        }, 10);
                                                    }, onCapsLockChange: showCapsLockWarning => {
                                                        setTimeout(() => {
                                                            setState({
                                                                showCapsLockWarning,
                                                            });
                                                        }, 10);
                                                    } }),
                                                react_1.default.createElement(reactstrap_1.Collapse, { className: errors.password ? 'form-error' : '', tag: reactstrap_1.FormText, color: "danger", isOpen: !!((state.passwordFocused &&
                                                        state.showCapsLockWarning) ||
                                                        (touched.password && errors.password)) },
                                                    errors.password,
                                                    ' ',
                                                    errors.password &&
                                                        state.showCapsLockWarning &&
                                                        ' | ',
                                                    state.showCapsLockWarning
                                                        ? 'Caps lock is on.'
                                                        : '')))))),
                                react_1.default.createElement("div", { className: "d-flex flex-row" },
                                    react_1.default.createElement("div", null,
                                        showButton !== false && (react_1.default.createElement(reusables_1.AjaxButton, { color: "dark", type: "submit", disabled: isSubmitting, error: mutationResult.error, success: !!mutationResult.data, loading: isSubmitting || mutationResult.loading, label: buttonText || 'Submit', successText: successText })),
                                        ' ',
                                        extraButton),
                                    react_1.default.createElement(react_if_1.When, { condition: !!(appSettings &&
                                            appSettings.enableMagicLinks &&
                                            showMagicLink === true) }, () => {
                                        return (react_1.default.createElement("div", { className: "ml-auto flex-col-centered" },
                                            react_1.default.createElement("div", null,
                                                react_1.default.createElement(MagicLinkButton, { email: values.email }))));
                                    })),
                                react_1.default.createElement(react_2.OsmosysErrorAlert, { apolloError: mutationResult.error }),
                                state.showWarningMessage && (react_1.default.createElement("p", { className: "mt-3" },
                                    react_1.default.createElement("small", null,
                                        "If you're seeing this message for longer than a few moments, please report this to the Osmosys team at",
                                        ' ',
                                        react_1.default.createElement("a", { href: "mailto:contact@yellowbrim.com?subject=Osmosys%20login%20bug" }, "contact@yellowbrim.com"),
                                        ' ',
                                        "and try logging in again.")))));
                        })))))));
}
exports.BaseAuthModal = BaseAuthModal;
//# sourceMappingURL=BaseAuthModal.js.map